import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

type Props = {
  name: string;
  image?: string | null;
  className?: string;
};

export function UserAvatar({ name, image, className }: Props) {
  const initials =
    (name ?? "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join("") || "?";

  return (
    <Avatar className={cn("h-8 w-8 rounded-lg", className)}>
      <AvatarImage src={image ?? undefined} alt={name} />
      <AvatarFallback className="rounded-lg text-base">{initials}</AvatarFallback>
    </Avatar>
  );
}
